<style scoped>
    @import '../../assets/css/sidebar.css';
</style>

<template>
    <div class="sidebar" >
        <div class="logo">
            <a href="#" class="simple-text logo-normal">
                <img src="../../assets/img/app/logo2.png" width="90px"/>
            </a>
        </div>
        <el-scrollbar style="height:96vh;">
            <el-menu
            background-color="#08192E"
            text-color="#fff"    
            :unique-opened="true"
            active-text-color="#fff"
            :collapse-transition="false"
            mode="vertical" 
             
            >
                <div class="sidebar-wrapper">   
                    <div v-for="item in routes" :key="item.path" :item="item" :base-path="item.path">
                        <div v-if="!item.hidden">
                            <template v-if="hasOneShowingChild(item.children,item)">
                                <div>
                                    <router-link :to="item.path" :index='item.path' v-if="permissionList.includes(item.permission)">
                                        <el-menu-item @click="closeBar()">
                                            <p class="m-0">
                                                <span :class="'dripicons-'+ item.icon" class="sidebar-icon"></span>
                                                {{$t(item.name)}}
                                            </p>
                                        </el-menu-item>
                                    </router-link>
                                </div>
                            </template>

                            <template v-else>
                                <el-submenu ref="subMenu" :index='item.path' v-if="permissionList.includes(item.permission)">                     
                                    <template slot="title">
                                        <p class="m-0">
                                            <span :class="'dripicons-'+ item.icon" class="sidebar-icon"></span>
                                            <span>{{$t(item.name)}}</span>
                                        </p>
                                    </template>
                                    <el-menu background-color="#15263B">
                                        <div v-for="child in item.children" :key="child.path" @click="getStatus()">
                                            <router-link :to="child.path" style="height:50px;">
                                                <el-menu-item v-if="permissionList.includes(child.permission)" @click="closeBar()">{{$t(child.name)}}</el-menu-item>
                                            </router-link> 
                                        </div>
                                    </el-menu>
                                </el-submenu>
                            </template>
                        </div>
                    </div>
                </div>
            </el-menu>
        </el-scrollbar>
    </div>
</template>

<script>
import {mainRouter} from '@/system/engine/router';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';
import {initialize} from '@/system/model/sidebar.js';

export default {
    inject:['preloader','reload'],
    data(){
        return{
            routes:mainRouter,
            permissionList:''
        }
    },methods:{
        hasOneShowingChild(children = [],parent) {
            if (children.length < 1 || parent.path == '/home') {
                return true
            }else{
                return false
            }
        },closeBar(){
            var root = document.getElementsByTagName( 'html' )[0];
            var toggled = document.getElementById('navbar-inline');
            
            root.removeAttribute('class');
            toggled.classList.remove("toggled")
        },getStatus() {
            this.$router.push(this.$route.path);
        }
    },created(){
        this.preloader(false);
        this.permissionList = JSON.parse(getLocalStorage('permission_list'));
    }
}
</script>
